import type { ServicepointVendor } from '~/modules/servicepointvendors/model'

export const initialServicepointVendor: ServicepointVendor = {
  address: {
    countryCode: 'NL',
    postalCode: '',
    // @ts-ignore - this is a bug in the model (FIXME in B2X-5593)
    number: '',
    houseNumberSuffix: '',
    street: '',
    city: '',
    isBusiness: false,
  },
  externalId: '',
  isPopular: false,
  name: '',
  rolcoNumber: '',
  id: '',
}
